import * as React from "react";
import { forwardRef } from "react";
const SvgAddIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.66732 5.66671H5.66732V9.66671H4.33398V5.66671H0.333984V4.33337H4.33398V0.333374H5.66732V4.33337H9.66732V5.66671Z", fill: "white" }));
const ForwardRef = forwardRef(SvgAddIcon);
export default ForwardRef;
